var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ah-active-filters" },
    [
      _vm._l(_vm.filters, function(filter, i) {
        return _c("active-filter", {
          key: "active-filter-" + i,
          attrs: {
            removeFilterAccessibleLabel: _vm.removeFilterAccessibleLabel,
            handleFilterRemove: function() {
              return _vm.handleFilterRemove(filter)
            },
            filter: filter
          }
        })
      }),
      _vm._v(" "),
      _vm.count > 0
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "ah-clear-filters",
                on: { click: _vm.handleClearFilters }
              },
              [
                _c("img", {
                  staticClass: "ah-clear-filters-icon",
                  attrs: { src: _vm.clearFiltersIconSrc, "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "ah-clear-filters-label" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.clearFiltersLabel) + "   \n      "
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }